<template>
  <div class="main-content item-create">
    <div class="page-header">
      <h3 class="page-title">{{ isEdit ? $t('communications.edit_communication') : $t('communications.new_communication') }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/dashboard">{{ $t('general.home') }}</router-link>
        </li>
        <li class="breadcrumb-item">
        <router-link slot="item-title" to="/super-admin/communications">{{ $tc('communications.communication',2) }}</router-link></li>
        <li class="breadcrumb-item"><a href="#"> {{ isEdit ? $t('communications.edit_communication') : $t('communications.new_communication') }}</a></li>
      </ol>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <form action="" @submit.prevent="submitCommunication">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{ $tc('communications.action_type',2) }}</label>
                    <base-select
                      v-model="formData.action_type"
                      :options="action_types"
                      :searchable="true"
                      :show-labels="false"
                      :placeholder="$t('communications.select_a_action_type')"
                      label="name"
                      track-by="id"
                    />
                    <div v-if="$v.formData.action_type.$error">
                      <span v-if="!$v.formData.action_type.required" class="text-danger">
                        {{ $tc('validation.type_required') }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{ $t('communications.subject') }}</label>
                    <base-input
                      v-model="formData.subject"
                      :placeholder="$t('communications.subject')"
                      label="name"
                    />
                    <div v-if="$v.formData.subject.$error">
                      <span v-if="!$v.formData.subject.required" class="text-danger">
                        {{ $tc('validation.subject_required') }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="message">{{ $t('communications.message') }}</label>
                    <base-text-area
                      v-model="formData.message"
                      rows="4"
                      name="message"
                      @input="$v.formData.message.$touch()"
                    />
                    <div v-if="$v.formData.message.$error">
                      <span v-if="!$v.formData.message.maxLength" class="text-danger">
                        {{ $t('validation.description_maxlength') }}
                      </span>
                    </div>
                  </div>
                  <div class="text-center">
                    <div class="form-group">
                      <base-button
                        :loading="isLoading"
                        :disabled="isSubmitDisabled"
                        icon="save"
                        color="theme"
                        type="submit"
                        class="collapse-button m-auto"
                      >
                        {{ isEdit ? $t('communications.update_communication') : $t('communications.save_communication') }}
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, minLength, numeric, minValue, maxLength, alphaNum } = require('vuelidate/lib/validators')

export default {
  mixins: {
    validationMixin
  },
  data () {
    return {
      isLoading: false,
      title: 'Add Item',
      formData: {
        id: '',
        action_type: '',
        subject: '',
        message: ''
      },
      userType: null,
      action_types: []
    }
  },
  computed: {
    isEdit () {
      if (this.$route.name === 'communications.edit') {
        return true
      }
      return false
    },
    isSubmitDisabled() {
      return this.$v.$invalid
    }
  },
  created () {
    this.fetchData()
    if (localStorage.getItem('role') == 'super_admin') {
      this.userType = 'super_admin'
    } else if (localStorage.getItem('account_type') == 'anchor') {
      this.userType = 'anchor'
    } else if (localStorage.getItem('account_type') == 'funder') {
      this.userType = 'funder'
    } else if (localStorage.getItem('account_type') == 'supplier') {
      this.userType = 'supplier'
    }
    if (this.isEdit) {
      this.loadEditData()
    }
  },
  validations: {
    formData: {
      action_type: {
        required
      },
      subject: {
        required
      },
      message: {
        required,
        maxLength: maxLength(255)
      }
    }
  },
  methods: {
    ...mapActions('communication', [
      'addCommunication',
      'updateCommunication',
      'fetchCommunication',
      'createCommunication'
    ]),
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('account', [
      'fetchAccounts'
    ]),
    async fetchData () {
      let response = await this.createCommunication()
      this.action_types = response.data.action_types
    },
    async loadAccounts () {
      let data = { pagination: 'no', status: 'active'}
      let response = await this.fetchAccounts(data)
      this.accounts = response.data.accounts.data
    },
    async loadEditData () {
      let response = await this.fetchCommunication(this.$route.params.id)
      this.formData.id = response.data.communication.id
      this.formData.subject = response.data.communication.subject
      this.formData.message = response.data.communication.message
      this.action_types = response.data.action_types
      this.formData.action_type = response.data.action_type
    },
    async submitCommunication () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return false
      }
      let data = {
        id: this.formData.id,
        action_type: this.formData.action_type.name,
        subject: this.formData.subject,
        message: this.formData.message
      }
      let response
      if (this.isEdit) {
        this.isLoading = true
        response = await this.updateCommunication(data)
      } else {
        response = await this.addCommunication(data)
      }
      if (response.data) {
        this.isLoading = false
        window.toastr['success'](this.$tc('communications.updated_message'))
        this.$router.push('/super-admin/communications')

        return true
      }
      window.toastr['error'](response.data.error)
    },
    async addItemUnit () {
      this.openModal({
        'title': 'Add Item Unit',
        'componentName': 'ItemUnit'
      })
    }
  }
}
</script>
